module.exports = __webpack_public_path__ + "static/media/5060.5b0b124c.jpg";